import { useAtomValue } from 'jotai';
import { ScopeProvider } from 'jotai-scope';
import { ReactNode } from 'react';
import { filterScopeIdAtom } from '@/atoms/filters/filter';
import { sectionAtom } from '@/atoms/section';
import { teamIdAtom, teamTypeAtom } from '@/atoms/team/team';
import { eventAtoms, radarAtoms, tableAtoms, visConfigAtoms } from '@/consts/scope';

const defaultDashboardAtoms = [...visConfigAtoms, ...radarAtoms, ...tableAtoms, ...eventAtoms];

export const DashboardWidgetScopeProvider = ({
  widgetId,
  metric,
  children,
}: {
  widgetId: string;
  metric?: string;
  children: ReactNode;
}) => {
  const section = useAtomValue(sectionAtom);
  const dashboardAtoms =
    section === 'game' ? [...defaultDashboardAtoms, teamIdAtom, teamTypeAtom] : defaultDashboardAtoms;

  const needsOwnFilterScope = Boolean(metric);
  const scopedAtoms = needsOwnFilterScope
    ? [...dashboardAtoms, [filterScopeIdAtom, `widget:${widgetId}`] as const]
    : dashboardAtoms;

  return <ScopeProvider atoms={scopedAtoms}>{children}</ScopeProvider>;
};
